import LayoutContent from '../../components/layouts/content2';
import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import CoctailScreen from './coctail.js';
import MargaritasScreen from './margaritas.js';
import WinesScreen from './wines.js';

function Index({ setShowHappy }) {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;

  const { change } = useRefresh();

  const [menus, setMenus] = useState([]);

  const [showSpecials, setShowSpecials] = useState(false);
  const [showCoctatik, setshowCoctatik] = useState(false);
  const [showMargaritas, setshowMargaritas] = useState(false);
  const [showWines, setshowWines] = useState(false);
  const [showListProduct, setShowListProduct] = useState(false);
  const [dishs, setdishs] = useState(false);

  const [tequila, settequila] = useState(false);
  const [cognac, setcognac] = useState(false);
  const [whiskey, setwhiskey] = useState(false);
  const [vodka, setvodka] = useState(false);
  const [liquours, setliquours] = useState(false);
  const [appetizers, setappetizers] = useState(false);
  const [bourbon, setbourbon] = useState(false);
  const [digestive, setdigestive] = useState(false);
  const [gin, setgin] = useState(false);
  const [rum, setrum] = useState(false);

  useEffect(() => {
    getData('menu').then((items) => {
      const data = items.value.data;

      setMenus(data);
    });
  }, [change]);

  useEffect(() => {
    menus.map((item) => {
      if (item.id === 403) {
        settequila(item);
      }
      if (item.id === 404) {
        setcognac(item);
      }
      if (item.id === 405) {
        setwhiskey(item);
      }
      if (item.id === 406) {
        setvodka(item);
      }
      if (item.id === 407) {
        setliquours(item);
      }
      if (item.id === 408) {
        setappetizers(item);
      }
      if (item.id === 409) {
        setbourbon(item);
      }
      if (item.id === 410) {
        setdigestive(item);
      }
      if (item.id === 411) {
        setgin(item);
      }
      if (item.id === 412) {
        setrum(item);
      }
    });
  }, [menus]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
      }}
    >
      <LayoutContent
        showBack={true}
        setShowSpecials={setShowSpecials}
        setShowListProduct={setShowHappy}
      >
        <div style={{ padding: '0 20px' }}>
          <h1
            style={{
              marginTop: 60,
              color: 'white',
              textTransform: 'uppercase',
              fontSize: 40,
              fontWeight: '900',
            }}
          >
            spirits & shots
          </h1>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              paddingInline: 30,
            }}
          >
            <div
              onClick={() => {
                setdishs(tequila);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  tequila
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(cognac);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  cognac
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(whiskey);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  whiskey
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(vodka);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  vodka
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(liquours);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  liquors
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(appetizers);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 41,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  appetizers drinks
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(bourbon);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  bourbon
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(digestive);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  digestives
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(gin);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  gin
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(rum);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginTop: 20,
                width: 290,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  rum
                </p>
              </div>
            </div>
          </div>

          {/* <img src={require('./assets/bannerdrink.png')} style={{marginTop: 20, objectFit: 'contain', width: 600}} /> */}
        </div>

        {showListProduct && (
          <ListProducts dishs={dishs} setShowListProduct={setShowListProduct} />
        )}

        {showCoctatik && <CoctailScreen setShowHappy={setshowCoctatik} />}
        {showMargaritas && (
          <MargaritasScreen setShowHappy={setshowMargaritas} />
        )}
        {showWines && <WinesScreen setShowHappy={setshowWines} />}

        {showSpecials && (
          <SpecialsScreen
            setShowListProduct={setShowSpecials}
            setShowHappy={setShowHappy}
          />
        )}
      </LayoutContent>
    </div>
  );
}
export default Index;
